export const lt = {
  brand: {
    name: "Laimės Dieta",
    tagline: "Vienintelė dieta, kurios verta laikytis",
  },
  nav: {
    bookstore: "Knygynas",
    lessons: "Pamokos",
    map: "Žemėlapis",
    archetype: "Archetipas",
    letters: "Laiškai",
    about: "Apie",
    profile: "Profilis",
    cart: "Krepšelis",
    unreadLetters: "Laiškai, neperskaityta: {count}",
    toggleMenu: "Toggle menu",
  },
  routes: {
    about: "/apie",
    auth: "/auth",
    profile: "/profilis",
    terms: "/naudojimosi-salygos",
    privacy: "/privatumo-politika",
    thankYou: "/aciu",
    install: "/instaliuoti",
    letters: "/naujienlaiskis",
    inbox: "/laiskai",
    map: "/zemelapis",
    mapSolo: "/zemelapis/solo",
    mapCareer: "/karjeros-zemelapis",
    mapFill: "/zemelapis/pildyti",
    couplesMap: "/poros-zemelapis",
    couplesCode: "/poros-zemelapis/kodas",
    couplesFill: "/poros-zemelapis/pildyti",
    archetype: "/archetipas",
    archetypeDetails: "/archetipas/anketa",
    unsubscribe: "/unsubscribe",
    acceptInvitation: "/priimti-kvietima",
    giftReceived: "/dovana-gauta",
  },
  footer: {
    links: "Nuorodos",
    contact: "Susisiekite",
    letters: "Laiškai",
    rights: "Visos teisės saugomos",
    terms: "Naudojimosi sąlygos",
    privacy: "Privatumo politika",
    top: "Į viršų",
  },
  home: {
    title: "Laimės Dieta | Saviugdos platforma moterims",
    description: "Laimės Dieta — saviugdos platforma moterims. Audio pamokos apie santykius, sprendimus, save. Knygynas, meditacijos, bendruomenė.",
    ogTitle: "Laimės Dieta | Saviugdos platforma",
    ogDescription: "Audio pamokos apie santykius, sprendimus, save. Žemė pilna dangaus.",
  },
  intlHome: {
    eyebrow: "Human, Mostly",
    headline: "A quiet system for understanding yourself.",
    body: "Take the free Archetype Test, build a SOLO Map in your own words, or create a Couples Map for the conversation you keep postponing.",
    primary: "Take the test",
    secondary: "Explore the maps",
    values: ["Free archetype test", "SOLO Map", "Couples Map", "Letters"],
    mapEyebrow: "The Maps",
    mapHeadline: "Not tests. Documents written from your own words.",
    soloTitle: "SOLO Map",
    soloBody: "A six-chapter portrait about where you are, what brought you here, and what wants to change.",
    couplesTitle: "Couples Map",
    couplesBody: "Two separate questionnaires, one shared map, and questions for the conversation afterwards.",
    manifestoEyebrow: "What we believe",
    manifesto: "Real happiness begins when you can look at your life without performing it.",
    newsletterEyebrow: "Letters",
    newsletterTitle: "Stay close to the work.",
    newsletterBody: "Occasional notes, new letters and openings from Rimantė.",
  },
  newsletter: {
    emailPlaceholder: "tavo el. paštas",
    submit: "Užsisakyti",
    invalidEmpty: "Įveskite el. pašto adresą",
    invalidFormat: "Neteisingas el. pašto formatas",
    invalidLong: "El. pašto adresas per ilgas",
    spamNote: "Patikrinkite ir „Spam“ / „Šlamštas“ aplanką, jei laiško nematote.",
    tooMany: "Per daug užklausų. Palaukite minutę.",
    genericError: "Įvyko klaida. Bandykite dar kartą.",
    pageTitle: "Rimantės laiškai — prenumerata | Laimės Dieta",
    pageDescription: "Kartą per savaitę parašau tau laišką. 5 € per mėnesį.",
    h1: "Rimantės laiškai",
    intro: "Kartą per savaitę parašau tau laišką. Ne straipsnį, ne patarimą. Laišką. Apie tai, ką tą savaitę pati\nbandau suprasti.",
    archive: "Laiškai",
    read: "Skaityti",
    readStart: "Skaityti pradžią",
    allLetters: "Visi laiškai",
    notFoundTitle: "Tokio laiško nėra",
    notFoundBody: "Gal nuoroda pasikeitė. Visus laiškus rasi sąraše.",
    paywallTitle: "Toliau — tik prenumeratoriams",
    paywallBody: "Likusią laiško dalį skaito prenumeratoriai. Kartą per savaitę parašau tau laišką.",
    subscribeCta: "Prenumeruoti – 5 € per mėnesį",
    cancelAnytime: "Atšaukti gali bet kada.",
  },
  common: {
    loading: "Kraunama...",
    comingSoon: "Netrukus",
  },
} as const;
